import React, { useEffect, useState } from "react";
import Container from "./PvinContainer";

// Simple loader
const Loader = () => (
  <div className="text-center py-4 text-gray-600 animate-pulse">
    Loading customer details...
  </div>
);

const CustomerDetails = ({ data }) => {
  const [showLoader, setShowLoader] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    // If data has arrived (even if empty), mark as "loaded"
    if (data !== undefined) {
      setHasLoaded(true);
    }

    // Show a loader temporarily when data is present
    if (data && data.length > 0) {
      setShowLoader(true);
      const timeout = setTimeout(() => {
        setShowLoader(false);
      }, 800);
      return () => clearTimeout(timeout);
    }
  }, [data]);

  // Case: Data hasn't loaded yet, just wait silently (no UI)
  if (!hasLoaded) {
    return null; // or a full-page loader if you prefer
  }

  // Case: Data has loaded, but is empty
  if (!data || data.length === 0) {
    return (
      <Container className="">
        <h2 className="text-xl font-semibold mb-2">Customer Details</h2>
        <div className="text-sm text-red-600">
          No subscription data available.
        </div>
      </Container>
    );
  }

  // Case: Data exists but still loading (brief loader)
  if (showLoader) {
    return (
      <Container>
        <h2 className="text-xl font-semibold mb-2">Customer Details</h2>
        <Loader />
      </Container>
    );
  }

  // Case: Data loaded and ready to render
  return (
    <Container>
      <h2 className="text-xl w-80 font-semibold mb-4">Customer Details</h2>
      <div className="space-y-3 text-md font-medium h-full">
        <div className="flex items-center">
          <p className="text-gray-700 font-semibold">Customer Name:</p>
        </div>
        <div>
          <p className="text-black overflow-hidden text-ellipsis whitespace-nowrap">
            {data[0]?.PAR_ACCNT_NAME || "N/A"}
          </p>
        </div>

        <div className="flex gap-2 bg-gray-100 pb-2 pl-1 pt-2 rounded">
          <span className="text-gray-700 font-semibold">Contact No:</span>
          <p className="text-black">{data[0]?.PAR_ACCNT_MAIN_PH_NUM || "N/A"}</p>
        </div>

        <div className="flex gap-2">
          <span className="text-gray-700 font-semibold">ARN:</span>
          <p className="text-black">{data[0]?.PAR_ACCNT_ARN || "N/A"}</p>
        </div>

        <div className="flex gap-2 bg-gray-100 p-2 rounded">
          <span className="text-gray-700 font-semibold">KA Code:</span>
          <p className="text-black">{data[0]?.PAR_ACCNT_LOCATION || "N/A"}</p>
        </div>
      </div>
    </Container>
  );
};

export default CustomerDetails;
